import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../theme/ThemeContext';

function BackArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  );
}

function SunIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5"/>
      <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
      <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </svg>
  );
}

export default function AuthNavbar() {
  const navigate = useNavigate();
  const { themeName, setThemeName } = useTheme();
  const toggleTheme = () => setThemeName(themeName === 'dark' ? 'light' : 'dark');

  return (
    <header style={headerStyle}>
      <div style={innerStyle}>
        {/* LEFT – back button */}
        <button type="button" onClick={() => navigate(-1)} style={iconBtnStyle} aria-label="Go back">
          <BackArrowIcon />
        </button>

        {/* CENTER – logo */}
        <span style={logoStyle}>Inverow</span>

        {/* RIGHT – theme toggle */}
        <button
          type="button"
          onClick={toggleTheme}
          style={iconBtnStyle}
          title={themeName === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {themeName === 'dark' ? <SunIcon /> : <MoonIcon />}
        </button>
      </div>
    </header>
  );
}

const headerStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 100,
  backdropFilter: 'var(--blur)',
  WebkitBackdropFilter: 'var(--blur)',
  background: 'var(--header-bg)',
  borderBottom: '1px solid var(--border)',
};

const innerStyle = {
  maxWidth: '1400px',
  margin: '0 auto',
  padding: '14px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const logoStyle = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  color: 'var(--header-text)',
  fontSize: '20px',
  fontWeight: 800,
  letterSpacing: '-0.5px',
  pointerEvents: 'none',
};

const iconBtnStyle = {
  background: 'rgba(255,255,255,0.12)',
  border: '1px solid rgba(255,255,255,0.22)',
  borderRadius: '10px',
  color: 'var(--header-text)',
  width: '42px',
  height: '42px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: 0,
  flexShrink: 0,
};
